export default {
  GET(state, data) {
    state.org_direction = { data }
  },
  LIST(state, data) {
    state.org_directions = data
  },
  UPDATE(state, value) {
    state.org_direction = {
      ...value,
      direction: value.direction.id,
    }
  },
  FRESH(state) {
    state.org_direction = {
      id: null,
      org: null,
      direction: null,
    }
  },
}
